export const MessageType = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    loading: "loading"
}